<div class="control-section">
    <!-- main content declaration -->
    <div id="target">
        <div class="sidebar-content">
            <section class="add-section mt-0 p-0"></section>

            <div class="dashboardParent">
                <ejs-tab (selected)="onTabSelected($event)">
                    <e-tabitems>
                        <e-tabitem>
                            <ng-template #headerText>
                                <div>{{ headerText1 }}</div>
                            </ng-template>
                            <ng-template #content>
                                <app-sales-graph #salesGraphComponent></app-sales-graph>
                            </ng-template>
                        </e-tabitem>
                        <e-tabitem>
                            <ng-template #headerText>
                                <div>{{ headerText2 }}</div>
                            </ng-template>
                            <ng-template #content>
                                <app-cashback-graph></app-cashback-graph>
                            </ng-template>
                        </e-tabitem>
                        <e-tabitem *ngIf="showAccountTab">
                            <ng-template #headerText>
                                <div>Account Information</div>
                            </ng-template>
                            <ng-template #content>
                                <app-account-information></app-account-information>
                            </ng-template>
                        </e-tabitem>
                    </e-tabitems>
                </ejs-tab>
            </div>
        </div>
    </div>
</div>
